import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const lampTypeOptions = ['LED', 'Compact Fluorescent', 'Incandescent', 'Halogen'];

const BuildingDetailsLampsAddLamp = ({ buildingId, lamp, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        lamp_type: '',
        number_of_lamps: '',
        daily_usage_hours: ''
    });

    useEffect(() => {
        if (lamp) {
            setFormData({
                lamp_type: lamp.lamp_type,
                number_of_lamps: lamp.number_of_lamps || '',
                daily_usage_hours: lamp.daily_usage_hours || ''
            });
        }
    }, [lamp]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            lamp_type: formData.lamp_type,
            number_of_lamps: parseInt(formData.number_of_lamps),
            daily_usage_hours: parseInt(formData.daily_usage_hours),
            building: parseInt(buildingId)
        };

        const url = lamp
            ? `/buildings/${buildingId}/lamps/${lamp.id}/`
            : `/buildings/${buildingId}/lamps/`;

        const method = lamp ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {lamp ? 'Edit Lamp' : 'Add Lamp'}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    select
                    label="Lamp Type"
                    name="lamp_type"
                    value={formData.lamp_type}
                    onChange={handleChange}
                    required
                    fullWidth
                    disabled={!!lamp}
                >
                    {lampTypeOptions.map(type => (
                        <MenuItem key={type} value={type}>{type}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    label="Number of Lamps"
                    name="number_of_lamps"
                    type="number"
                    value={formData.number_of_lamps}
                    onChange={handleChange}
                    fullWidth
                    required
                    inputProps={{ min: 0, step: 1 }}
                />
                <TextField
                    label="Daily Usage Hours"
                    name="daily_usage_hours"
                    type="number"
                    value={formData.daily_usage_hours}
                    onChange={handleChange}
                    fullWidth
                    required
                    inputProps={{ min: 0, step: 1 }}
                />

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" type="submit">
                        {lamp ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsLampsAddLamp;
